var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper } from '@material-ui/core';
import { FlexGrowRow } from '@xyo-network/sdk-xyo-react-js';
import { FaUser } from 'react-icons/fa';
import { useAuthUser } from '../hooks';
const sizePixels = {
    large: 128,
    medium: 64,
    small: 32,
};
const ProfileImageViewer = (props) => {
    const buttonProps = __rest(props, []);
    const user = useAuthUser();
    const sizeToUse = sizePixels.medium;
    return (_jsxs(Paper, Object.assign({}, buttonProps, { children: [(user === null || user === void 0 ? void 0 : user.photoURL) ? (_jsx(FlexGrowRow, { children: _jsx("img", { src: user === null || user === void 0 ? void 0 : user.photoURL, height: sizeToUse, width: sizeToUse }, void 0) }, void 0)) : null,
            (user === null || user === void 0 ? void 0 : user.photoURL) === undefined ? (_jsx(FlexGrowRow, Object.assign({ style: { opacity: 0.2 } }, { children: _jsx(FaUser, { size: 32 }, void 0) }), void 0)) : null] }), void 0));
};
export default ProfileImageViewer;
